export default {
  appName: "GESTÃO DE FROTA",
  urlImages: "https://api.sigfrotagov.com.br/uploads/",
  menu: {
    drawer: true,
  },
  loader: false,
  modules: [
    { name: "prefectures", nome: "prefeituras" },
    { name: "prefectures", nome: "prefeituras c/ almoxarifado" },
    { name: "drivers", nome: "motoristas" },
    { name: "providers", nome: "fornecedores" },
    { name: "attendants", nome: "frentistas" },
  ],
  userData: (() => {
    try {
      const stored = sessionStorage.getItem("userData");
      return stored ? JSON.parse(stored) : [];
    } catch (e) {
      return [];
    }
  })(),
  userPermissions: [],
};
